import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { CommonMethodService } from "../../common/commonMethod.service";
import { ResidentService } from "../../services/resident.service";
import { UserService } from "../../services/user.service";
@Component({
    selector: 'app-import-vehicle',
    templateUrl: './importVehicle.component.html',
    providers: [CommonMethodService, ResidentService, UserService]
})

export class ImportVehicleComponent implements OnInit, OnDestroy {
    subscribe: Array<Subscription> = [];
    loader: boolean = false;

    accountId: string;
    flatId: string;

    // Vehicle 
    download: boolean = false;
    file: any;
    fileName: Array<string> = [];



    constructor(private toaster: ToastrService, private residentService: ResidentService, private activeRoute: ActivatedRoute,
        private route: Router, private commonMethod: CommonMethodService, private userService: UserService) { }
    ngOnInit(): void {
        this.accountId = sessionStorage.getItem('accountId');
        this.flatId = sessionStorage.getItem('flatId');
    }


    onFileChange(event) {
        if (event.target.files.length > 0) {
            this.file = event.target.files[0];
        }
    }
    // Onsubmit File
    onSubmit(): void {
        const formData = new FormData();
        if (this.file === undefined) {
            this.toaster.error('Please select excel sheet');
            return;
        }
        formData.append('file', this.file);
        this.loader = true;
        this.subscribe.push(this.residentService.importCommercialVehicle(formData, this.accountId, this.flatId).subscribe(
            data => {
                this.loader = false;
                const wrapper = JSON.parse(JSON.stringify(data));
                if (wrapper.Error > 0) {
                    this.download = true;
                    this.fileName = wrapper.url.split('.');
                }
                this.toaster.success(wrapper.Message);
                this.ngOnInit();
            }, error => {
                this.loader = false;
                this.commonMethod.returnErrorMessage(error);
            }));

    }



    //Download Sample Sheet 
    downloadSampleSheet(): void {
        this.loader = true;
        this.subscribe.push(this.residentService.downloadSampleSheet('vehicle.xlsx').subscribe(
            data => {
                this.loader = false;
                const file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }, error => {
                this.loader = false;
                const file = new Blob([error.error.text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.commonMethod.returnErrorMessage(error);
            }));
    }


    // Download Error Sheet
    downloadErrorSheet(): void {
        this.loader = true;
        this.subscribe.push(this.residentService.downloadErrorVehicleSheet(this.fileName[0]).subscribe(
          data => {
            this.loader = false;
            const file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
    
          }, error => {
            this.loader = false;
            const file = new Blob([error.error.text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.commonMethod.returnErrorMessage(error);
          }));
    
      }

    ngOnDestroy(): void {
        this.subscribe.forEach(destroyExistingValue => {
            destroyExistingValue.unsubscribe();
        });
    }

}
